import { Google, Pixall } from '../analytics/index.js';
export async function writeReviewCTAClick(_ref, option) {
  let {
    data = {},
    dataLayer
  } = _ref;
  const {
    pixallData
  } = data;
  Pixall.sendClickEvent({
    eventType: 'click',
    label: 'write-a-review',
    eventSource: 'dealership',
    ...pixallData
  }, dataLayer, option);
  Google.sendClickEvent({
    eventElement: 'dealer-rating',
    eventResult: 'write-a-review'
  }, option);
  return {};
}
export async function seeDealerReviewCTAClick(_ref2, option) {
  let {
    data = {},
    dataLayer
  } = _ref2;
  const {
    pixallData
  } = data;
  Pixall.sendClickEvent({
    eventType: 'click',
    label: 'see-dealer-reviews',
    eventSource: 'dealership',
    ...pixallData
  }, dataLayer, option);
  Google.sendClickEvent({
    eventElement: 'dealer-rating',
    eventResult: 'see-dealer-reviews'
  }, option);
  return {};
}
export function dealerClick(_ref3, option) {
  let {
    data = {},
    dataLayer
  } = _ref3;
  const {
    ownerId,
    par,
    hasListingType = true,
    pixallData
  } = data;
  Pixall.sendClickEvent({
    pixallData,
    label: 'dealer_srp',
    eventSource: 'dealership',
    listingCode: ownerId,
    hasListingType,
    par
  }, dataLayer, option);
  return {
    ownerId: ownerId?.toString()
  };
}
export default {
  seeDealerReviewCTAClick,
  writeReviewCTAClick,
  dealerClick
};